<template lang="pug">
#laudo-mut-pastagem
    slot
    .modal-container-inner-filtros
        .selecao-ano-final-analise
            .title
                | {{ $t('mensagens.laudos.mutPastagem.anoFinalPeriodoAnalise') }}
                span.invalido(v-if='anoFinalAnalise === null') &nbsp;*
                el-select.selecao_ano(
                    v-model='anoFinalAnalise',
                    :placeholder="$t('mensagens.comuns.selecione')",
                    clearable,
                    @clear='anoFinalAnalise=null'
                )
                    el-option(
                        v-for='anoSelecionado in anosDisponiveis',
                        :key='anoSelecionado.id',
                        :label='anoSelecionado.ano',
                        :value='anoSelecionado.id'
                    )

        .title.title-padding
            | {{ $t('mensagens.laudos.mutPastagem.arquivoExcelListaCar') }}
            span.invalido(v-if='!uploadCompleto') &nbsp;*
            div.busca
                    SelecionarArquivoPlanilha(
                        @cancelar-modal='changeShowModalSelecionarTerritorio',
                        @checar-upload='checarStatusUpload',
                        :tipoLaudo='tipoLaudo',
                        :anoFinalAnalise='getAnoSelecionado()'
                    )

</template>

<script>
import TipoLaudo from '@/constants/TipoLaudo';
import SelecionarArquivoPlanilha from '@/components/laudos/SelecionarArquivoPlanilha.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'Laudos',
    components: {
        SelecionarArquivoPlanilha
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    mounted() {
        this.anosSelecao();
    },
    data() {
        return {
            anoFinalAnalise: null,
            uploadCompleto: false,
            anosDisponiveis: [],
            tipoLaudo: TipoLaudo.MUT_E_PASTAGEM,
            loading: false
        };
    },
    methods: {
        anosSelecao() {
            var anoAtual = new Date().getFullYear();
            var anoMin = 2022;
            var anos = [];

            for (let i = 0; i <= (anoAtual - anoMin); i++) {
                let ano = {
                    'id': i,
                    'ano': anoAtual - i
                };
                anos.push(ano);
            }

            this.anosDisponiveis = anos;
        },

        getAnoSelecionado() {
            return this.anoFinalAnalise !== null ? this.anosDisponiveis[this.anoFinalAnalise].ano.toString() : null;
        },

        changeShowModalSelecionarTerritorio() {
            this.showModalSelecionarTerritorios =
                !this.showModalSelecionarTerritorios;

            this.$emit('showModalSelecionarTerritorios');
        },

        checarStatusUpload(statusUpload) {
            this.uploadCompleto = statusUpload;
        }
    }
};
</script>

<style scoped lang="scss">
#laudo-mut-pastagem {
    .laudo-margin {
        margin-bottom: 20px;
    }

    .title-padding {
        padding: 15px 0px 5px 0px;
    }

    .selecao-ano-final-analise {
        display: flex;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .selecao_ano {
        margin-left: 8px;
        width: 110px;
    }
}
</style>
